import styled from '@emotion/styled';
import React from 'react';

import { color, font } from 'src/shared/styles/variables';
import checkMark from 'src/shared/svg/checkmark.svg';

interface Props {
    wasPasswordEdited: boolean;
    isValid: boolean;
    text: string;
    testID?: string;
}

interface ValidationProps {
    wasPasswordEdited: boolean;
    isValid: boolean;
}

const Validation = styled.div<ValidationProps>(
    ({ wasPasswordEdited, isValid }) => ({
        color: isValid
            ? color.cornflowerBlueDark
            : wasPasswordEdited
            ? color.wildWatermelon
            : color.blueBayoux,
        lineHeight: '22px',
        paddingRight: '10px',
    }),
    font.size.base,
);

export const PasswordValidationElement: React.FC<Props> = ({
    wasPasswordEdited,
    isValid,
    text,
    testID,
}) => {
    return (
        <Validation wasPasswordEdited={wasPasswordEdited} isValid={isValid} data-testid={testID}>
            {isValid ? (
                <span>
                    <img data-testid={`${testID}-img`} src={checkMark} />{' '}
                </span>
            ) : (
                <span>• </span>
            )}
            {text}
        </Validation>
    );
};
